import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { getAdvertiserSetting as _getAdvertiserSetting, setAdvertiserSetting as _setAdvertiserSetting } from '@/api/advertiser/manage.ts';
import { PermissionKey } from '@pt/enums/user';

export default {
  name: 'advertiserEditPopover.vue',

  props: {
    advertiser: {
      type: Object,
      required: true
    },

    visible: {
      type: Boolean,
      required: true
    }
  },

  data: function data() {
    return {
      saving: false,
      loading: false,

      model: {
        creative_final_review: 2, // 是否需要二审 1是 2否
        pt_allow_down_creative_file: 2, // 是否允许客户在 playturbo 下载素材，1 允许，2 不允许
        is_inner_test_account: false, // 是否内测账号
        pt_mintegral_account_limit: 1, // 广告主授权帐号上限
        inner_test_permissions: {
          insights: false
        }
      },

      formConfig: {
        labelPosition: 'left'
      }
    };
  },


  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    dialogAttrs: function dialogAttrs() {
      return {
        title: '\u5E7F\u544A\u4E3B\u540D\u79F0 ' + this.advertiser.name
      };
    },
    submitButtonAttrs: function submitButtonAttrs() {
      return {
        type: 'primary',
        size: 'mini',
        loading: this.saving
      };
    },
    cancelButtonAttrs: function cancelButtonAttrs() {
      return {
        size: 'mini',
        loading: this.saving
      };
    },
    schema: function schema() {
      var _this = this;

      return {
        type: 'object',
        properties: {
          creative_final_review: {
            component: 'switch',
            title: '客户上传/制作素材需要二次审核：',
            field: {
              activeValue: 1,
              inactiveValue: 2
            }
          },
          pt_allow_down_creative_file: {
            component: 'switch',
            title: '允许客户在 Playturbo 下载非交互素材：',
            field: {
              activeValue: 1,
              inactiveValue: 2
            }
          },
          is_inner_test_account: {
            component: 'switch',
            title: '是否内测账号：',
            field: {
              listeners: {
                change: function change(val) {
                  if (!val) {
                    _this.model.inner_test_permissions.insights = false;
                  }
                }
              }
            }
          },
          inner_test_permissions: {
            type: 'object',
            visible: this.model.is_inner_test_account,
            class: 'inner-test-permissions',
            border: false,
            properties: {
              insights: {
                component: 'switch',
                title: '授权客户使用数据看板'
              }
            }
          },
          pt_mintegral_account_limit: {
            component: 'input',
            title: 'MTG可授权广告账户数:',
            field: {
              type: 'number',
              style: 'width: 200px;'
            },
            rules: [{ required: true, message: '请输入数字', trigger: 'blur' }, { validator: this.validateInteger, trigger: 'blur' }]
          }
        }
      };
    }
  },

  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val === false) {
        this.saving = false;
        this.loading = false;
      } else {
        this.$refs.form && this.$refs.form.resetFields();
        this.getAdvertiserSetting();
      }
    }
  },

  methods: {
    handleSubmit: function handleSubmit() {
      this.setAdvertiserSetting();
    },
    validateInteger: function validateInteger(rule, value, callback) {
      var reg = /^[0-9]+$/;
      if (!reg.test(value)) {
        callback(new Error('请输入整数'));
      } else if (value <= 0) {
        callback(new Error('请输入大于0的整数'));
      } else {
        callback();
      }
    },
    close: function close() {
      this.dialogVisible = false;
    },
    getAdvertiserSetting: function getAdvertiserSetting() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, adv, inner_test_permissions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return _getAdvertiserSetting({
                  params: {
                    id: _this2.advertiser.id
                  }
                });

              case 3:
                res = _context.sent;
                adv = _.get(res, 'data.data.adv');

                _this2.model.creative_final_review = Number(_.get(adv, 'creative_final_review'));
                _this2.model.pt_allow_down_creative_file = Number(_.get(adv, 'pt_allow_down_creative_file')) || 2;

                _this2.model.pt_mintegral_account_limit = Number(_.get(adv, 'pt_mintegral_account_limit')) || 1;

                inner_test_permissions = _.get(adv, 'inner_test_permissions') || [];

                _this2.model.is_inner_test_account = inner_test_permissions.length > 0;
                _this2.model.inner_test_permissions.insights = inner_test_permissions.includes(PermissionKey.Insights);

                _this2.loading = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setAdvertiserSetting: function setAdvertiserSetting() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var model;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.saving = true;
                model = {
                  pt_allow_down_creative_file: _this3.model.pt_allow_down_creative_file,
                  creative_final_review: _this3.model.creative_final_review,
                  inner_test_permissions: [],
                  pt_mintegral_account_limit: _this3.model.pt_mintegral_account_limit
                };


                if (_this3.model.is_inner_test_account) {
                  if (_this3.model.inner_test_permissions.insights) {
                    model.inner_test_permissions.push(PermissionKey.Insights);
                  }
                }

                _context2.next = 6;
                return _setAdvertiserSetting({
                  params: {
                    id: _this3.advertiser.id
                  },
                  data: model
                });

              case 6:
                _this3.$message.success('保存成功');
                _this3.saving = false;
                _this3.close();

                _this3.$emit('success');
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                _this3.saving = false;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    }
  }
};